import React from 'react'
import NavPatient from '../../patients/navPatien/NavPatient'
import Contact from '../Contact'


function ContactPatient() {
    return (
        <div>
            <NavPatient menu={'contact'} />
            <Contact disabledMenu />
        </div>
    )
}

export default ContactPatient